import PropTypes from 'prop-types';
import React, { Component } from 'react';
import SeasonCarousel from './season_carousel';
import EpisodeCarousel from './episode_carousel';
import { sendAnalyticsEvent } from '../../../utils/analytics';
import {some, findIndex} from 'lodash';
import { injectIntl } from 'react-intl';

export class ShowNav extends Component {
  constructor(props) {
    super(props);
    this.state = { activeSeasonIdx: this.initialActiveSeasonIdx() };
  }

  shouldComponentUpdate = (nextProps, nextState) =>
    nextProps.entryId !== this.props.entryId
    || nextState.activeSeasonIdx !== this.state.activeSeasonIdx;

  handleSeasonClick = (idx) => {
    if (idx === this.state.activeSeasonIdx) {
      return;
    }

    sendAnalyticsEvent(
      'Season Carousel',
      'Click',
      this.props.seasons[idx].name
    );

    this.setState({ activeSeasonIdx: idx });
  };

  activeSeason = () =>
    this.props.seasons[this.state.activeSeasonIdx] || {};

  initialActiveSeasonIdx = () =>
    findIndex(
      this.props.seasons,
      ({ episodes }) => some(episodes, ({ id }) => id === this.props.entryId)
    );

  seasonCarousel = () => (
    <SeasonCarousel slides={this.props.seasons}
      activeSlideIdx={this.state.activeSeasonIdx}
      handleSlideClick={this.handleSeasonClick}
      intl={this.props.intl}
    />
  );

  shouldDisplaySeasonCarousel = () =>
    this.props.seasons.length > 1;

  render = () => (
    <div className="show">
      {this.shouldDisplaySeasonCarousel() && this.seasonCarousel()}
      <EpisodeCarousel slides={this.activeSeason().episodes}
        entryId={this.props.entryId}
        seasonIdx={this.state.activeSeasonIdx}
        intl={this.props.intl}
      />
    </div>
  );
}

export default injectIntl(ShowNav);

ShowNav.propTypes = {
  entryId: PropTypes.number.isRequired,
  seasons: PropTypes.arrayOf(PropTypes.object).isRequired,
  intl: PropTypes.object.isRequired
};
